"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var spotPagePath = function spotPagePath(_id, slug) {
  return "/surf-report/" + slug + "/" + _id;
};

exports.default = spotPagePath;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/spotPagePath.js
// module id = 292
// module chunks = 11